import request from '@/utils/request'

// 查询列表
export function findDirectorItems(params) {
    return request({
        url: `/director_items`,
        method: 'get',
        params: params
    })
}

// 更新
export function updateDirectorItem(id, data) {
    return request({
        url: `/director_items/${id}`,
        method: 'put',
        data
    })
}

// 创建
export function createDirectorItem(data) {
    return request({
        url: `/director_items`,
        method: 'post',
        data
    })
}

// 删除
export function deleteDirectorItem(id) {
    return request({
        url: `/director_items/${id}`,
        method: 'delete'
    })
}

// 更新有效性
export function updateDirectorItemEffective(id, data) {
    return request({
        url: `/director_items/${id}/effective`,
        method: 'patch',
        data
    })
}
